import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-contract-product-create-modal',
    templateUrl: './contract-product-create-modal.component.html',
    styleUrls: ['./contract-product-create-modal.component.scss'],
    standalone: false
})
export class ContractProductCreateModalComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
